var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#spinner_svg__a)",
  d: "M13.58 2.26a8 8 0 0 1 2.38 4.91c.04.39-.28.71-.67.72-.4 0-.71-.32-.76-.71A6.58 6.58 0 0 0 8 1.43V0c2 0 4.15.87 5.58 2.26"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#spinner_svg__b)",
  d: "M0 8c0-2 .88-4.18 2.28-5.6A8.44 8.44 0 0 1 8 0v1.43A6.8 6.8 0 0 0 3.3 3.4 7.04 7.04 0 0 0 1.43 8z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#spinner_svg__c)",
  d: "M2.37 13.7A8.43 8.43 0 0 1 0 8h1.43c0 1.72.77 3.5 1.95 4.68A6.74 6.74 0 0 0 8 14.57V16c-2 0-4.2-.9-5.63-2.3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#spinner_svg__d)",
  d: "M14.41 9.43a6.6 6.6 0 0 1-1.76 3.21A7.3 7.3 0 0 1 8 14.57V16a8.7 8.7 0 0 0 5.67-2.35A8 8 0 0 0 16 8h-1.43c-.02.5-.06.99-.16 1.43"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "spinner_svg__a",
  x1: 8.28,
  x2: 15.29,
  y1: 0.57,
  y2: 7.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "spinner_svg__b",
  x1: 7.71,
  x2: 0.56,
  y1: 0.57,
  y2: 7.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "spinner_svg__c",
  x1: 0.71,
  x2: 7.71,
  y1: 8.29,
  y2: 15.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "spinner_svg__d",
  x1: 8.28,
  x2: 15.43,
  y1: 15.43,
  y2: 8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0
})))));
export default SvgSpinner;